import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ClassCourseItem from './ClassCourseItem';

function ClassUserProgressMd({ userId, isOpen, onClose }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProgressions, setUserProgressions] = useState([]);
  const records = useSelector((state) => state.class.records);

  useEffect(() => {
    setCurrentUser(records.users.find((user) => user.id === userId));
    setUserProgressions(
      records.progressionRecords.filter((record) => record.ownerId === userId)
    );
  }, [userId, records]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Progress of {currentUser?.name}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {records.courses.map((course) => (
            <ClassCourseItem
              key={course.id}
              records={records}
              course={course}
              userProgressions={userProgressions}
            />
          ))}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

ClassUserProgressMd.defaultProps = {
  userId: null,
};

ClassUserProgressMd.propTypes = {
  userId: PropTypes.number,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ClassUserProgressMd;
